import { Stack, styled } from "@mui/material";

export const InsuredEventImage = styled("img")(({ theme }) => ({
    height: 233,
    objectFit: "contain"
}));

export const InsuredStack = styled(Stack)(({ theme }) => theme.unstable_sx({
    display: "flex",
    flexDirection: "column",
    spacing: 5,

    [theme.breakpoints.up("md")]: {
        flexDirection: "row-reverse",
        justifyContent: "center",
        alignItems: "center",
        gap: '2rem'
    },
}));
